/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_DanishInputs */



/**
* | output |
* | --- |
* | "Danish" |
*
* @param {Speechmatics_Target_Language_DanishInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_danish = /** @type {((inputs?: Speechmatics_Target_Language_DanishInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_DanishInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Danois")
	if (locale === "de") return /** @type {LocalizedString} */ ("dänisch")
	if (locale === "it") return /** @type {LocalizedString} */ ("danese")
	if (locale === "ru") return /** @type {LocalizedString} */ ("датский")
	if (locale === "es") return /** @type {LocalizedString} */ ("danés")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("丹麦语")
	if (locale === "ja") return /** @type {LocalizedString} */ ("デンマーク語")
	if (locale === "hi") return /** @type {LocalizedString} */ ("डेनिश")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("dinamarquês")
	return /** @type {LocalizedString} */ ("Danish")
});